// Safe Harbor Status — PSD §9.2 (F9.2). Report rail + Dashboard card badge.

import type { SafeHarbor } from '@backsolve/shared-types';

interface SafeHarborStatusProps {
  safeHarbor: SafeHarbor;
  windowDays?: number;
}

const LABELS: Record<SafeHarbor, { label: string; badge: string; description: string }> = {
  independentAppraisal: {
    label: 'Independent Appraisal',
    badge: 'badge-success',
    description: 'Presumption of reasonableness under §409A(h)(1)(C) and Reg. §1.409A-1(h).',
  },
  illiquidStartup: {
    label: 'Illiquid Startup',
    badge: 'badge-success',
    description: 'Binding-formula safe harbor for illiquid startup stock.',
  },
  bindingFormula: {
    label: 'Binding Formula',
    badge: 'badge-info',
    description: 'Binding formula method — not repudiated within 90 days.',
  },
  none: {
    label: 'None',
    badge: 'badge-warning',
    description: 'No safe harbor claimed. FMV is fully challengeable by the IRS.',
  },
};

export function SafeHarborStatus({ safeHarbor, windowDays }: SafeHarborStatusProps) {
  const info = LABELS[safeHarbor];
  return (
    <div className="safe-harbor-status">
      <span className={`badge ${info.badge}`}>{info.label}</span>
      <p className="field-hint">{info.description}</p>
      {windowDays !== undefined && safeHarbor !== 'none' && (
        <p className="field-hint">Safe-harbor window: {windowDays} days remaining.</p>
      )}
    </div>
  );
}
